export default __webpack_public_path__ + "static/poster-b298caad3b0c0a11676db5e981d07e45.png";